import { createContext, useContext } from "react";
import {
	DEFAULT_VERITY_INSTITUTE_SETTINGS,
	EditQuizType,
	ExemptedStudent,
	VerityInstituteSettings,
} from "../../types/common";
import { OptionRelatedInstituteSettings, ProctoringOption } from "@verity/proctoring-option/types";
import { EnabledProctoringOptions } from "@verity/api-client/types";
import { DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES, DEFAULT_PROCTORING_OPTION } from "@verity/proctoring-option";
import { RenderableProctoringKey } from "../proctoring-options/option-text/ProctoringOptionText";

export const StandAloneExemptedStudentsContext = createContext<{
	studentList: { name: string; userId: number }[];
	exemptedStudents: ExemptedStudent[];
	isCreating?: boolean;
}>({ studentList: [], exemptedStudents: [] });

const PROCTORING_OPTION_CONTEXT_DEFAULTS = {
	enforcedProfilesOnly: false,
	optionRelatedInstituteSettings: undefined,
	proctoringOption: DEFAULT_PROCTORING_OPTION,
	setProctoringOption: () => {},
	verityInstituteSettings: DEFAULT_VERITY_INSTITUTE_SETTINGS,
	enabledProctoringOptions: DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES,
	proctoringOptionToFocus: undefined,
	onFocusProctoringOption: undefined,
	isMobileLayout: false,
	quizType: undefined,
};

export const ProctoringOptionContext = createContext<{
	proctoringOption: Partial<ProctoringOption>;
	setProctoringOption: (options: Partial<ProctoringOption>) => void;
	verityInstituteSettings: VerityInstituteSettings;
	enforcedProfilesOnly: boolean;
	optionRelatedInstituteSettings: OptionRelatedInstituteSettings | undefined;
	enabledProctoringOptions: EnabledProctoringOptions;
	proctoringOptionToFocus: RenderableProctoringKey | undefined;
	onFocusProctoringOption?: () => void;
	isMobileLayout: boolean;
	quizType?: EditQuizType;
}>(PROCTORING_OPTION_CONTEXT_DEFAULTS);

export const useProctoringOptionContext = () => useContext(ProctoringOptionContext);

export const EditQuizToastContext = createContext<string | undefined>(undefined);
export const useEditQuizToast = () => useContext(EditQuizToastContext);
